
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-36db401b!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./StaticBlockRow.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./StaticBlockRow.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-36db401b!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./StaticBlockRow.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./dev/src/components/StaticBlockRow.vue
// module id = ./dev/src/components/StaticBlockRow.vue
// module chunks = 0